<template>
  <mdb-container>
    <mdb-tbl striped responsive>
      <mdb-tbl-body>
        <tr v-for="guest in guests" :key="guest.id">
          <td><h4 class="text-info">{{ guest.guestName }}</h4>
            {{ guest.link }}
          </td>
          <td>
            <mdb-btn title="Copy Link" aria-label="Copy Link" icon="copy" size="sm" floating tag="a"
                     @click="copyLink(guest.link)"/>
            <mdb-btn title="Revoke" aria-label="Revoke" icon="trash" size="sm" color="danger" floating tag="a"
                     @click="deleteGuest(guest)"/>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <mdb-input v-model="guestName" label="Add a Guest" placeholder="New Guest Name">
      <mdb-btn slot="append" @click="addGuest" :disabled="!guestName" icon="user-plus" size="sm">Add Guest</mdb-btn>
    </mdb-input>

    <yes-no-modal @yes="doDeleteGuest" @no="deleteModal = false" v-if="deleteModal"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import YesNoModal from "../common/YesNoModal";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "guest-manager",
  order: 1,
  components: {
    mdbContainer,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbBtn,
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    YesNoModal
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
  },
  props: {
    event: {
      type: Object,
      default: null
    },
    instantMeeting: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      guests: [],
      guestName: "",
      deleteModal: false,
      deleteCandidate: null
    }
  },
  mounted() {
    this.loadGuests()
  },
  methods: {
    deleteGuest(guest) {
      this.deleteCandidate = guest
      this.deleteModal = true
    },
    async copyLink(url) {
      if (!navigator.clipboard) {
        this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
        return
      }
      try {
        await navigator.clipboard.writeText(url)
        this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
      } catch (e) {
        this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
      }
    },
    loadGuests() {
      this.$store.dispatch("setExecuting", true)
      let src,id

      if (this.event != null) {
        src = "event"
        id = this.event.eventId
      }
      if (this.instantMeeting != null) {
        src = "meeting"
        id = this.instantMeeting.id
      }
      let url = `/jitsi/${src}Guests/${id}`

      api.get(url).then(
        (results) => {
          this.guests = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addGuest() {
      this.$store.dispatch("setExecuting", true)
      let src,id

      if (this.event != null) {
        src = "event"
        id = this.event.eventId
      }
      if (this.instantMeeting != null) {
        src = "meeting"
        id = this.instantMeeting.id
      }
      let url = `/jitsi/${src}Guests/${id}`

      api.post(url, {guestName: this.guestName}).then(
        (results) => {
          this.guests = results.data
          this.guestName = ""
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doDeleteGuest() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true)
      let src,id

      if (this.event != null) {
        src = "event"
        id = this.event.eventId
      }
      if (this.instantMeeting != null) {
        src = "meeting"
        id = this.instantMeeting.id
      }
      let url = `/jitsi/${src}Guests/${id}?guest=${this.deleteCandidate.id}`

      api.delete(url).then(
        (results) => {
          this.guests = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};

</script>

